module.exports = __webpack_public_path__ + "static/7059b97f-a6c4-4ec7-bfad-c7b04d7f9703-a562f29065d3fdfc0cab844dd8289e2b.webp";